import { useEffect } from 'react'
import { MULTIPLAYER_UI } from '../config/multiplayer'

interface Props {
  open: boolean
  onClose: () => void
  onRandomMatch: () => void
  onFriendMatch: () => void
}

/**
 * オンライン対戦メニュー。
 *
 * TitleScreen の「オンライン対戦」ボタン押下後、ログイン済みの場合に表示する。
 * 「ランダムマッチ」か「あいことば」かを選ばせる。
 *
 * スタイルは AuthLoginModal / HelpModal と同じ `.auth-modal__*` クラスを流用する
 * （モーダル UX の一貫性のため、CSS は追加しない）。
 */
export function MultiplayerMenu({ open, onClose, onRandomMatch, onFriendMatch }: Props) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  if (!open) return null

  return (
    <div
      className="auth-modal__overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mp-menu-title"
      onClick={onClose}
    >
      <div className="auth-modal__dialog" onClick={(e) => e.stopPropagation()}>
        <header className="auth-modal__header">
          <h2 id="mp-menu-title" className="auth-modal__title">
            {MULTIPLAYER_UI.menuTitle}
          </h2>
          <button
            type="button"
            className="auth-modal__close"
            aria-label="閉じる"
            onClick={onClose}
          >
            ×
          </button>
        </header>

        <div className="auth-modal__body">
          <div className="auth-modal__providers">
            <button
              type="button"
              className="btn btn--primary btn--large"
              onClick={onRandomMatch}
            >
              <strong>{MULTIPLAYER_UI.menuRandomLabel}</strong>
              <span style={{ display: 'block', fontSize: 12, opacity: 0.8, marginTop: 4 }}>
                {MULTIPLAYER_UI.menuRandomDescription}
              </span>
            </button>
            <button
              type="button"
              className="btn btn--secondary btn--large"
              onClick={onFriendMatch}
            >
              <strong>{MULTIPLAYER_UI.menuFriendLabel}</strong>
              <span style={{ display: 'block', fontSize: 12, opacity: 0.8, marginTop: 4 }}>
                {MULTIPLAYER_UI.menuFriendDescription}
              </span>
            </button>
          </div>
          <p className="auth-modal__note">
            マルチプレイ対戦ではスタミナを消費しません。
          </p>
        </div>
      </div>
    </div>
  )
}
